<div class="store" woa-responsive
     [ngClass]="{
         'minimal': configurationModel.isWaiterActor(),
         'summary': summary(),
         'with-actions': canShowActions(),
         'with-store-image': configurationModel.isConsumerActor() && showStoreImage(),
         'with-map': configurationModel.isConsumerActor() && canShowMap()
     }">
    @if (configurationModel.isConsumerActor() && showStoreImage() && responsiveService.desktop()) {
        <div class="store-image">
            <img class="store-image-object" alt=""
                 [woa-image-cache]="store().image"
                 [ngClass]="{
                     'emptyImg': (!store().image?.id && !store().image?.image),
                     'clickable': !canShowOrderTypes()
                 }"
                 woa-activatable (onActivate)="orderHere()">
        </div>
    }
    <div class="store-main">
        <div class="store-main-header">
            <div class="store-main-header-name" [class.minimal]="configurationModel.isWaiterActor()">
                {{ store().collectiveStoreName }}
            </div>
            @if (configurationModel.isConsumerActor() && showStateWithName()) {
                <div class="store-main-header-state">
                    {{ store().state }}
                </div>
            }
            @if (configurationModel.isConsumerActor() && canShowDistance()) {
                <div class="store-main-header-distance">
                    {{ 'woa.label.store-details.distance' | translate: {'distance': store().distance | distance} }}
                </div>
            }
        </div>
        <div class="store-main-body">
            @if (configurationModel.isConsumerActor()) {
                <div class="store-main-body-details">
                    <div class="store-main-body-details-static">
                        @if (showStoreImage() && responsiveService.mobile()) {
                            <div class="store-main-body-details-static-image store-image">
                                <img class="store-image-object" alt=""
                                     [woa-image-cache]="store().image"
                                     [ngClass]="{
                                         'emptyImg': (!store().image?.id && !store().image?.image),
                                         'clickable': !canShowOrderTypes()
                                     }"
                                     woa-activatable (onActivate)="orderHere()">
                            </div>
                        }
                        <div class="store-main-body-details-static-info">
                            @if (showAddress() || canShowDescription()) {
                                <div woa-touchable #text
                                     class="store-main-body-details-static-info-text"
                                     [ngClass]="{'collapsible': canCollapseText(text)}"
                                     [woa-css-var]="{'--line-height': StoreDetailsPanelComponent.TEXT_LINE_HEIGHT + 'px'}"
                                     woa-activatable (onActivate)="toggleText(text)">
                                    <div class="store-main-body-details-static-info-text-details">
                                        @if (canShowDescription()) {
                                            <div class="store-main-body-details-static-info-text-details-detail">
                                                {{ store().description }}
                                            </div>
                                        }
                                        @if (showAddress()) {
                                            <div class="store-main-body-details-static-info-text-details-detail">
                                                {{ store().street }}, {{ store().city }} {{ store().postcode ? store().postcode : store().state }}
                                            </div>
                                        }
                                    </div>
                                    @if (canCollapseText(text)) {
                                        <woa-toggle class="store-main-body-details-static-info-text-toggle"
                                                    [active]="!textCollapsed()"></woa-toggle>
                                    }
                                </div>
                            }
                            @if (canShowTelephone()) {
                                <woa-link class="store-main-body-details-static-info-telephone"
                                          [label]="'woa.label.store-details.phoneNumber'"
                                          [link]="'woa.button.store-details.phoneNumber'"
                                          [translationParams]="{'number': store().telephone}"
                                          (onActivate)="callPhone()"></woa-link>
                            }
                            @if (showMoreDetails()) {
                                <woa-link class="store-main-body-details-static-info-more"
                                          [link]="'woa.button.store-details.moreDetails'"
                                          (onActivate)="onStoreDetails.emit()"></woa-link>
                            }
                        </div>
                    </div>
                    @if (showStatus()) {
                        <woa-store-status-panel class="store-main-body-details-status"
                                                [store]="store()"
                                                [filteredOrderType]="filteredOrderType()"></woa-store-status-panel>
                    }
                </div>
            }
            @if (canShowActions()) {
                <div class="store-main-body-actions">
                    @if (canShowOrderTypes()) {
                        <div class="store-main-body-actions-label">{{ 'woa.button.store-details.orderHere' | translate }}</div>
                        <div class="store-main-body-actions-options">
                            @if (canOrder()(OrderType.ORDER_AT_TABLE)) {
                                <woa-button class="store-main-body-actions-options-option"
                                            [tier]="ButtonTier.SECOND" [prominence]="ButtonProminence.LOW"
                                            [label]="'woa.button.store-details.orderAtTable'"
                                            (onActivate)="orderHere(OrderType.ORDER_AT_TABLE)"></woa-button>
                            }
                            @if (canOrder()(OrderType.ORDER_AHEAD)) {
                                <woa-button class="store-main-body-actions-options-option"
                                            [tier]="ButtonTier.SECOND" [prominence]="ButtonProminence.LOW"
                                            [label]="'woa.button.store-details.orderAhead'"
                                            (onActivate)="orderHere(OrderType.ORDER_AHEAD)"></woa-button>
                            }
                            @if (canOrder()(OrderType.ORDER_DELIVERY)) {
                                <woa-button class="store-main-body-actions-options-option"
                                            [tier]="ButtonTier.SECOND" [prominence]="ButtonProminence.LOW"
                                            [label]="'woa.button.store-details.orderDelivery'"
                                            (onActivate)="orderHere(OrderType.ORDER_DELIVERY)"></woa-button>
                            }
                        </div>
                    } @else {
                        <woa-button class="store-main-body-actions-options-option"
                                    [tier]="ButtonTier.SECOND" [prominence]="ButtonProminence.LOW"
                                    [label]="'woa.button.store-details.orderHere'"
                                    (onActivate)="orderHere()"></woa-button>
                    }
                </div>
            }
        </div>
    </div>
    @if (configurationModel.isConsumerActor() && canShowMap()) {
        <div class="store-main-location">
            <div class="store-main-location-main">
                <woa-store-map-panel class="store-main-location-main-map" [store]="store()"></woa-store-map-panel>
            </div>
            @if (store().latitude && store().longitude) {
                <woa-link class="store-main-location-link"
                          [link]="'woa.button.store-details.directions'" (onActivate)="getDirections()"></woa-link>
            }
        </div>
    }
</div>
